export const GET_PRICE_LIST = "GET_PRICE_LIST";
export const PRICE_LIST_FETCH_ERROR = "PRICE_LIST_FETCH_ERROR";